import { Skeleton } from "antd";
import { lazy, Suspense } from "react";
import { useTranslation } from "react-i18next";
import type { LateSeriesPoint } from "../utils/lateSeries";

/**
 * ⚠️⚠️ **DINAMIK import — `@ant-design/plots` bo'lagi 432,56 kB gzip**
 * (`bun run build` bilan o'lchangan; dastlabki taxmin ~200 KB edi).
 *
 * `lazyRouteComponent` bu yerda YORDAM BERMAYDI: `/employees/$id`
 * marshruti `routeTree.tsx` da STATIK import qilinadi (ilovadagi yagona
 * lazy marshrutlar — `/zones` va uch xarita sahifasi). Shuning uchun
 * bo'lak SAHIFA ICHIDA ajratiladi.
 *
 * ⚠️ Statik importga qaytarilsa `employees-bundle.test.ts` ning uchinchi
 * testi qizil bo'ladi — u AYNAN shu qatorning shaklini pinlaydi.
 */
const LateBarChart = lazy(() => import("./charts/LateBarChart"));

/**
 * happy-dom'da `<canvas>` konteksti bormi.
 *
 * ⚠️⚠️ **O'LCHANGAN: bu repozitoriyda `document.createElement("canvas")
 * .getContext("2d")` `null` QAYTARADI** (xato tashlamaydi). G2
 * kontekstsiz render qila olmaydi, ya'ni testda diagramma noaniq
 * holatga tushardi — `EmployeeDetailPage.test.tsx` «Umumiy» yorlig'ini
 * render qiladi va `await act(async () => …)` dinamik import
 * promise'ini hal qilishi MUMKIN, ya'ni «bo'lak testda hech qachon
 * yuklanmaydi» deb tахmin qilib bo'lmaydi.
 *
 * Determinizm shu sababdan `React.lazy` DAN OLDIN, imkoniyat tekshiruvi
 * bilan olinadi. Brauzerda tekshiruv har doim `true`.
 */
function canvasBormi(): boolean {
	try {
		return document.createElement("canvas").getContext("2d") !== null;
	} catch {
		return false;
	}
}

export function LateChartSlot({ series }: { series: LateSeriesPoint[] }) {
	const { t } = useTranslation("employees");

	if (!canvasBormi()) {
		return <div className="text-xs text-[#8a929e]">{t("lateChart.fallback")}</div>;
	}

	return (
		<Suspense fallback={<Skeleton.Node active style={{ width: "100%", height: 160 }} />}>
			<LateBarChart series={series} />
		</Suspense>
	);
}
